import { RouteLocationNormalized, NavigationGuardNext, RouteRecordRaw } from 'vue-router';

const servicesChildGuard = (to: RouteLocationNormalized, from: RouteLocationNormalized, next: NavigationGuardNext) => {
	if (from.name || to.name === 'FilterDetailsAutomatic') {
		next();
	} else {
		next('/konto/uslugi-produkty');
	}
};

const filterPrefix = ':filterId' || 'dodaj-polecanie';

export default [
	{
		path: '/konto/profil/uslugi-produkty',
		redirect: '/konto/uslugi-produkty',
	},
	{
		path: '/konto/uslugi-produkty',
		name: 'Services',
		component: () => import('@customer/profile/services/ServicesPage.vue'),
		/** Wywalone beforeEnter bo teraz jest potrzeba by był query param */
		/* beforeEnter: (to: RouteLocationNormalized, from: RouteLocationNormalized, next: NavigationGuardNext) => {
					// TODO: Dlaczego chcemy się pozbywać tutaj queryStringa?
					if (Object.keys(to.query).length) {
						next(to.path);
					} else {
						next();
					}
				},
		*/
		children: [
			{
				name: 'FilterCreate',
				path: 'dodaj',
				component: () => import('@customer/profile/services/FilterCreate.vue'),
				beforeEnter: (to: RouteLocationNormalized, from: RouteLocationNormalized, next: NavigationGuardNext) => {
					if (from.name !== 'Services') {
						next('/konto/uslugi-produkty');

						return;
					}

					servicesChildGuard(to, from, next);
				},
			},
			{
				name: 'FilterListItem',
				path: ':categoryId',
				component: () => import('@customer/profile/services/FilterListItem.vue'),
				beforeEnter: servicesChildGuard,
				children: [
					{
						name: 'FilterPricing',
						path: 'ceny',
						component: () => import('@customer/profile/services/FilterPricing.vue'),
						beforeEnter: servicesChildGuard,
					},
					{
						name: 'FilterDetailsMatching',
						path: `${filterPrefix}/dopasowanie`,
						component: () => import('@customer/profile/services/FilterDetails/FilterDetailsMatching.vue'),
						beforeEnter: servicesChildGuard,
					},
					{
						name: 'FilterDetailsLocation',
						path: `${filterPrefix}/lokalizacje`,
						component: () => import('@customer/profile/services/FilterDetails/FilterDetailsAutomatic.vue'),
						beforeEnter: servicesChildGuard,
					},
					{
						name: 'FilterDetailsQuick',
						path: `${filterPrefix}/szybki-kontakt`,
						component: () => import('@customer/profile/services/FilterDetails/FilterDetailsQuick.vue'),
						beforeEnter: servicesChildGuard,
						children: [
							{
								name: 'FilterDetailsQuickMatching',
								path: 'dopasowanie',
								component: () => import('@customer/profile/services/FilterDetails/FilterDetailsMatching.vue'),
							},
							{
								name: 'FilterDetailsQuickLocation',
								path: 'lokalizacje',
								component: () => import('@customer/profile/services/FilterDetails/FilterDetailsAutomatic.vue'),
							},
						],
					},
					{
						name: 'FilterDetailsAutomatic',
						path: `${filterPrefix}/polecanie`,
						component: () => import('@customer/profile/services/FilterDetails/FilterDetailsAutomatic.vue'),
						beforeEnter: servicesChildGuard,
						children: [
							{
								name: 'FilterDetailsAutomaticMatching',
								path: 'dopasowanie',
								component: () => import('@customer/profile/services/FilterDetails/FilterDetailsMatching.vue'),
							},
							{
								name: 'FilterDetailsAutomaticLocation',
								path: 'lokalizacje',
								component: () => import('@customer/profile/services/FilterDetails/FilterDetailsLocation.vue'),
							},
						],
					},
				],
			},

		],
	},
	{
		path: '/konto/uslugi-produkty/:pathMatch(.*)*',
		name: 'NotFound',
		beforeEnter: (to: RouteLocationNormalized, from: RouteLocationNormalized, next: NavigationGuardNext) => {
			// @TODO 404 page
			next('/');
		},
	},
] as RouteRecordRaw[];
